export type InAppBrowserType = 'tiktok' | 'instagram' | 'facebook' | 'snapchat' | 'twitter' | 'other' | null;

export interface InAppBrowserInfo {
  isInAppBrowser: boolean;
  browserType: InAppBrowserType;
  appName: string;
}

export function useInAppBrowser(): InAppBrowserInfo {
  const ua = typeof navigator !== 'undefined' ? navigator.userAgent.toLowerCase() : '';

  if (ua.includes('musical_ly') || ua.includes('tiktok') || ua.includes('bytedancewebview') || ua.includes('aweme')) {
    return { isInAppBrowser: true, browserType: 'tiktok', appName: 'TikTok' };
  }
  if (ua.includes('instagram')) {
    return { isInAppBrowser: true, browserType: 'instagram', appName: 'Instagram' };
  }
  if (ua.includes('fban') || ua.includes('fbav') || ua.includes('fb_iab')) {
    return { isInAppBrowser: true, browserType: 'facebook', appName: 'Facebook' };
  }
  if (ua.includes('snapchat')) {
    return { isInAppBrowser: true, browserType: 'snapchat', appName: 'Snapchat' };
  }
  if (ua.includes('twitter') || ua.includes('twitterandroid') || ua.includes('twitter_')) {
    return { isInAppBrowser: true, browserType: 'twitter', appName: 'Twitter / X' };
  }

  return { isInAppBrowser: false, browserType: null, appName: '' };
}
